import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TabletIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Tablet",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m25.77 29.02.07-.09c.55-.59.89-1.38.89-2.25V5.33c0-1.84-1.49-3.32-3.33-3.33H8.59C6.75 2 5.27 3.49 5.26 5.33v21.84c.1 1.59 1.41 2.84 3.01 2.84H23.5c.85 0 1.62-.35 2.18-.9l.08-.09ZM14.6 26.74v-.03a1.419 1.419 0 1 1 1.42 1.42c-.61 0-1.13-.38-1.33-.92-.06-.15-.09-.31-.09-.47M8.59 4.8H23.4c.29 0 .53.24.53.53v18.16H8.06V5.33c0-.29.24-.53.53-.53"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M25.57 31.86H7.29c-1.89 0-3.43-1.54-3.43-3.43V3.29C3.86 1.4 5.4-.14 7.29-.14h18.29c1.89 0 3.43 1.54 3.43 3.43v25.14c0 1.89-1.54 3.43-3.43 3.43ZM7.29 2.14c-.63 0-1.14.51-1.14 1.14v25.14c0 .63.51 1.14 1.14 1.14h18.29c.63 0 1.14-.51 1.14-1.14V3.29c0-.63-.51-1.14-1.14-1.14H7.29Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.57 6.71h-2.29a1.14 1.14 0 1 1 0-2.28h2.29a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};